"use client";

import * as RadixRadioGroup from "@radix-ui/react-radio-group";
import { useId } from "react";

export interface RadioOption {
  value: string;
  label: string;
}

export interface RadioGroupProps {
  label: string;
  options: RadioOption[];
  value: string | undefined;
  onValueChange: (value: string) => void;
  disabled?: boolean;
  name?: string;
}

/** One choice from a short, mutually exclusive set. */
export function RadioGroup({
  label,
  options,
  value,
  onValueChange,
  disabled,
  name,
}: RadioGroupProps) {
  const groupId = useId();
  return (
    <fieldset>
      <legend className="ui-legend">{label}</legend>
      <RadixRadioGroup.Root
        value={value}
        onValueChange={onValueChange}
        disabled={disabled}
        name={name}
        className="flex flex-col gap-2"
      >
        {options.map((option) => {
          const optionId = `${groupId}-${option.value}`;
          return (
            <div className="ui-option-row" key={option.value}>
              <RadixRadioGroup.Item id={optionId} value={option.value} className="ui-radio-root">
                <RadixRadioGroup.Indicator className="ui-radio-indicator" />
              </RadixRadioGroup.Item>
              <label htmlFor={optionId}>{option.label}</label>
            </div>
          );
        })}
      </RadixRadioGroup.Root>
    </fieldset>
  );
}
